module.exports = __webpack_public_path__ + "img/store.0e9d665b.png";